import {
  Divider,
  IconButton,
  Typography,
  CircularProgress,
  Box,
  Modal,
  Button,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  DeleteSanad,
  listfilesanad,
  ListSanadUser,
} from "../../services/user/user";
import { useNavigate } from "react-router-dom";
import { Alert, Confirm } from "../../utils/alert";
import RefreshIcon from "@mui/icons-material/Refresh";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import QRCode from "react-qr-code";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import ShareIcon from "@mui/icons-material/Share";
import { useTranslation } from "react-i18next";
export default function Card({
  namesanad,
  codesanad,
  codepoya,
  datesabt,
  idstrsanad,
  deleteSanad,
  updateSanad,
  timeRemaining,
  onRestartTimer,
}) {
  const navigate = useNavigate();
  const [isShareDisabled, setIsShareDisabled] = useState(false);
  const [currentCodePoya, setCurrentCodePoya] = useState(codepoya);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { t } = useTranslation();

  // Timer states
  const [timeLeft, setTimeLeft] = useState(timeRemaining);
  const [endTime, setEndTime] = useState(Date.now() + timeRemaining * 1000);
  const [isRunning, setIsRunning] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const qrValue = `${codesanad}-${codepoya}`;

  useEffect(() => {
    // Whenever the parent’s timeRemaining changes, update local timer state
    setTimeLeft(timeRemaining);
    if (timeRemaining > 0) {
      setIsRunning(true);
      setIsShareDisabled(false);
    } else {
      setIsRunning(false);
      setIsShareDisabled(true);
    }
  }, [timeRemaining]);

  // Timer countdown effect
  useEffect(() => {
    if (!isRunning || timeLeft <= 0) {
      if (timeLeft <= 0) {
        setTimeLeft(0);
        setIsRunning(false);
        setIsShareDisabled(true);
      }
      return;
    }

    const interval = setInterval(() => {
      const newTimeLeft = Math.max(
        0,
        Math.floor((endTime - Date.now()) / 1000)
      );
      setTimeLeft(newTimeLeft);

      if (newTimeLeft <= 0) {
        clearInterval(interval);
        setIsRunning(false);
        setIsShareDisabled(true);
        if (modalIsOpen) {
          closeModal();
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [endTime, isRunning, modalIsOpen, closeModal]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        const newTimeLeft = Math.max(
          0,
          Math.floor((endTime - Date.now()) / 1000)
        );
        setTimeLeft(newTimeLeft);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [endTime]);

  const restartTimer = async () => {
    setIsLoading(true);
    try {
      const result = await onRestartTimer(idstrsanad);
      if (result && result.success) {
        const newEndTime = Date.now() + 120 * 1000; // Set new end time 120 seconds from now
        setEndTime(newEndTime);
        setTimeLeft(120);
        setIsRunning(true);
        setIsShareDisabled(false);
      }
    } catch (err) {
      console.error("Error restarting timer:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  const percentage = (timeLeft / 120) * 100;

  const handleView = async () => {
    try {
      const response = await listfilesanad(idstrsanad); // API call

      if (response.status === 200 && response.data.value) {
        // Navigate to the specific page after successful API call
        navigate(`/sanad/${idstrsanad}`);
      } else {
        throw new Error("Invalid Response"); // Handle any invalid response
      }
    } catch (err) {
      // Show a popup in case of an error
      Swal.fire({
        title: t("FileExpired.Title"),
        text: t("FileExpired.Text"),
        confirmButtonText: t("Progress.ok"),
      });
    }
  };

  const handleDelete = async () => {
    const { value } = await Confirm(
      t("Common.Delete"),
      t("Common.DeleteConfirm")
    );
    if (value) {
      try {
        await DeleteSanad(idstrsanad);
        deleteSanad(idstrsanad);
        Alert(t("Common.Delete"), t("Common.DeleteSuccess"), "");
      } catch (error) {}
    }
  };

  const handleShare = async () => {
    const shareData = {
      title: t("Home.ShareTitle", { name: namesanad }),
      text: t("Home.ShareText", { codesanad, codepoya: currentCodePoya }),
      url: window.location.href,
    };

    try {
      await navigator.clipboard.writeText(
        `${shareData.title}\n${shareData.text}`
      );

      if (navigator.share) {
        await navigator.share(shareData);
        toast.success(t("Home.CopySuccess"));
        return;
      }

      toast.success(t("Home.CopiedToClipboard"));
    } catch (error) {}
  };

  // Update currentCodePoya when codepoya prop changes
  useEffect(() => {
    setCurrentCodePoya(codepoya);
  }, [codepoya]);

  return (
    <div className="flex flex-col bg-purple text-ice-white p-3 rounded-xl">
      <div className="flex justify-between mb-[.60rem]">
        <div className="flex flex-col">
          <Typography variant="h4">{namesanad}</Typography>
        </div>
        <Typography variant="h4">{datesabt}</Typography>
      </div>
      <Divider sx={{ backgroundColor: "white", opacity: 0.6 }} />
      <div className="flex justify-between px-4 my-3">
        <div className="flex flex-col justify-evenly items-start">
          <div className="flex gap-3">
            <Typography variant="h4">{t("Home.docId")}</Typography>
            <Typography variant="h2">{codesanad}</Typography>
          </div>
          <div className="flex justify-center items-end gap-3">
            <Typography variant="h4">{t("Home.OTP")}</Typography>
            {!isShareDisabled ? (
              <>
                <Typography variant="h2">{currentCodePoya}</Typography>
                <IconButton
                  size="small"
                  sx={{
                    color: "#008A70",
                    padding: "3px",
                    backgroundColor: "white",
                    borderRadius: "12px",
                    "&:hover": {
                      backgroundColor: "#EDF4FF",
                    },
                  }}
                  onClick={handleShare}
                >
                  <ShareIcon />
                </IconButton>
              </>
            ) : (
              <Typography variant="h5">{t("Home.OTPExpired")}</Typography>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-2 text-center items-center">
          <Typography variant="h5">{t("Home.OTPValidTime")}</Typography>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box position="relative" width={80} height={80}>
              <CircularProgress
                variant="determinate"
                value={100}
                size={80}
                thickness={3}
                sx={{ color: "#d4d4d4" }}
              />
              <CircularProgress
                variant="determinate"
                value={percentage}
                size={80}
                thickness={3}
                sx={{
                  color: "#008A70",
                  position: "absolute",
                  left: 0,
                  transition: "all 1s ease-in-out",
                }}
              />
              <Box
                position="absolute"
                top={0}
                left={0}
                bottom={0}
                right={0}
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
              >
                {isLoading ? (
                  <CircularProgress size={20} sx={{ color: "white" }} />
                ) : timeLeft === 0 ? (
                  <IconButton
                    onClick={restartTimer}
                    disabled={isLoading}
                    size="large"
                    sx={{
                      color: "#008A70",
                      backgroundColor: "white",
                      "&:hover": {
                        backgroundColor: "white",
                      },
                      padding: "12px",
                    }}
                  >
                    <RefreshIcon sx={{ fontSize: 21 }} />
                  </IconButton>
                ) : (
                  <Typography
                    variant="body2"
                    component="div"
                    fontWeight="bold"
                    sx={{ color: "white" }}
                    aria-live="polite"
                  >
                    {formatTime(timeLeft)}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        </div>
      </div>
      <Divider sx={{ backgroundColor: "white", opacity: 0.6 }} />
      <div>
        <div className="flex mt-3 justify-between">
          <div className="flex gap-2 items-center "></div>
          <div className="flex gap-4">
            <IconButton
              onClick={openModal}
              disabled={isShareDisabled}
              aria-label="scan"
              size="small"
              sx={{
                backgroundColor: "#EDF4FF",
                color: "#4a4a4a",
                "&:hover": {
                  backgroundColor: "#EDF4FF",
                },
                "&:active": {
                  backgroundColor: "#EDF4FF",
                },
                "&:disabled": {
                  backgroundColor: "#EDF4FF70",
                },
              }}
            >
              <QrCodeScannerIcon />
            </IconButton>
            <IconButton
              aria-label="view"
              size="small"
              sx={{
                backgroundColor: "#EDF4FF",
                color: "#0C72D7",
                "&:hover": {
                  backgroundColor: "#EDF4FF",
                },
                "&:active": {
                  backgroundColor: "#EDF4FF",
                },
              }}
              onClick={handleView}
            >
              <VisibilityIcon />
            </IconButton>
            <IconButton
              aria-label="delete"
              size="small"
              sx={{
                backgroundColor: "#EDF4FF",
                color: "#C81D11",
                "&:hover": {
                  backgroundColor: "#EDF4FF",
                },
                "&:active": {
                  backgroundColor: "#EDF4FF",
                },
              }}
              onClick={handleDelete}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        </div>
        <Modal
          open={modalIsOpen}
          onClose={closeModal}
          aria-labelledby="modal-qr-code"
          aria-describedby="modal-qr-code-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "white",
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
              p: 4,
              outline: "none",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 3,
              animation: "fadeIn 0.3s ease-out",
              "@keyframes fadeIn": {
                from: { opacity: 0, transform: "translate(-50%, -48%)" },
                to: { opacity: 1, transform: "translate(-50%, -50%)" },
              },
            }}
          >
            <Box sx={{ p: 2, bgcolor: "white", borderRadius: "8px" }}>
              <QRCode value={qrValue} size={200} />
            </Box>
            <Button variant="text" onClick={closeModal} color="primary">
              {t("Common.Close")}
            </Button>
          </Box>
        </Modal>
      </div>
    </div>
  );
}
